<template>
  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div class="user_view__header--info"> 
        <div>
          <h1>Dispositivos</h1>
          <h4>Listado de dispositivos registrados</h4>
        </div>
      </div>
      <div class="user_view__header--sec1">
        <button  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}" @click="toUpdate" >ACTUALIZAR</button>
        <button v-if="getRol() == 'admin'" class="primary_button" @click="$router.push({ name: 'CreateDevice' })" >CREAR</button>
      </div>
      <info-table :name="'dispositivos'" :columns="columns" :items.sync="devices" :actions="true"/>

      <div class="info_table__foot">
              <div/>
              <div class="paginator">
                {{shownItemsFrom}} - {{shownItemsTo}} 
                <div class="paginator__numbers">
                  <div v-for="(page,i) in total_pages" @click="handlePageChange(i+1)" :key=i class="paginator__numbers--num" :class="{'active': currentPage==i+1}">
                    {{i+1}}
                  </div>
                  <div class="paginator__numbers--num" @click="handlePageChange(currentPage+1)">
                    >
                  </div>
                </div>
              </div>
      </div>

    </section>
  </article>
</template>

<script>
import moment from 'moment';
import Table from './../shared/Table';
export default {
  
  data(){
    return{
      columns:[
        {
          name: 'Última modificación',
          sortable: true,
        },
        {
          name: 'Nombre',
          sortable: true,
        },
        /*{
          name: 'IMEI',
          sortable: true,
        },*/
        {
          name: 'Teléfono',
          sortable: true,
        },
        
        {
          name: 'Acciones',
          enabled: true,
        }
      ],

      mockedDevices:[
        {
          updated_at: '2019-04-16T15:04:44.539-05:00',
          name: 'Iphone X',
          imei: '41313 321315 123213',
          number:'31768585835',
          status: false,
          device: {
            location:'Piso 1 - Entrada 6 - Edificio de Gobernación de Neiva',
            company: 'Coca-Cola'
          }
        },
        
      ],
      devices:[],
      isUpdate:false,
      total_pages: 0,
      currentPage: 1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      maxPage:12,
    }
  },
  methods:{

    handlePageChange(value) {
      this.currentPage = value;
      this.toUpdate()
    },

    month_name(dt){
      var mlist = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
        return mlist[dt.getMonth()];
    },
    toUpdate(){
      this.isUpdate=true;  
      setTimeout(() => { this.isUpdate=false; }, 200);  
      
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card; 
      this.$resource('devices'+ '?page=' + this.currentPage,{},customActions).get({"id_card":card})
      .then(function(data){
        this.total_pages = data.body.total_pages
        this.devices=data.body.data;      
      }).catch(function(err){
      console.log(err.body.error_text);
    });
    }
  },
  components:{
      'info-table':Table, 
  },
  created(){

    this.toUpdate();
    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Devices.vue